"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var SVGIcon = styled_components_1.default.svg(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    polygon {\n        ", "\n    }\n"], ["\n    polygon {\n        ",
    "\n    }\n"])), function (_a) {
    var isDisabled = _a.isDisabled, isError = _a.isError, theme = _a.theme;
    if (isDisabled) {
        return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                    fill: ", ";\n                "], ["\n                    fill: ", ";\n                "])), theme.colorControlIconDisabled);
    }
    else if (isError) {
        return styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                    fill: ", ";\n                "], ["\n                    fill: ", ";\n                "])), theme.colorControlIconError);
    }
    return styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n                fill: ", ";\n            "], ["\n                fill: ", ";\n            "])), theme.colorControlIcon);
});
exports.ArrowUpSVGIcon = function (props) { return (react_1.default.createElement(SVGIcon, __assign({}, props, { viewBox: "0 0 10 6.409", width: "10px", height: "6.409px", focusable: "false" }),
    react_1.default.createElement("polygon", { points: "0 4.994 1.412 6.409 5 2.815 8.588 6.409 10 4.994 5.002 0 0 4.994" }))); };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=ArrowUp.js.map